import React, { useEffect, useState } from 'react'
import { Card, CardContent } from '../../components/ui/card'
import { showLoader, hideLoader, getParameterByName, goToHomePage } from '../../helpers/Utils'
import { Input } from '../../components/ui/input'
import { Button } from '../../components/ui/button'
import { Label } from '../../components/ui/label'
import '../../assets/styleSheets/login.scss'
import { CDN_URL } from '../../constants/siteConstant'
import { jwtDecode } from 'jwt-decode'
import { useTranslation } from 'react-i18next'
import { tryResettingPassword, tryResettingPasswordForNewAndExpiredUser } from '../../services/auth'
import { useNavigate } from 'react-router-dom'

const errorStyle = {
  fontSize: '12px',
  color: 'red',
  marginTop: '4px'
}
export default function ResetPasswordNew () {
  const [state, setState] = useState({
    formData: { password: '', confirmPassword: '' },
    passwordError: '',
    confirmPasswordError: '',
    token: '',
    showPassword: { password: false, confirmPassword: false },
    steps: 1
  })
  const [resetPasswordEmail, setResetPasswordEmail] = useState('')
  const { t } = useTranslation(['auth'])
  const navigate = useNavigate()

  const { formData, passwordError, confirmPasswordError, showPassword, steps } = state

  useEffect(() => {
    const res = getParameterByName('token', window.location.href)
    const tokenData = res && jwtDecode(res)
    setResetPasswordEmail(tokenData?.email)
    setState((prevState) => ({ ...prevState, token: res }))
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    setState((prevState) => ({
      ...prevState,
      formData: {
        ...prevState.formData,
        [name]: value
      },
      passwordError: name === 'password' && value.length < 8 ? 'Passwort sollte mindestens 8 Zeichen lang sein' : '',
      confirmPasswordError: name === 'confirmPassword' ? '' : prevState.confirmPasswordError
    }))
  }

  const handleTogglePasswordVisibility = (field) => {
    setState((prevState) => ({
      ...prevState,
      showPassword: {
        ...prevState.showPassword,
        [field]: !prevState.showPassword[field]
      }
    }))
  }

  const handleSubmit = async () => {
    const { formData, token } = state
    let hasError = false
    if (!formData.password) {
      setState((prevState) => ({ ...prevState, passwordError: 'Passwort erforderlich' }))
      hasError = true
    }

    if (!formData.confirmPassword) {
      setState((prevState) => ({ ...prevState, confirmPasswordError: 'Bitte Passwort bestätigen' }))
      hasError = true
    }

    if (hasError) return

    if (formData.password === formData.confirmPassword) {
      try {
        showLoader()
        let response
        if (token) {
          response = await tryResettingPassword(token, formData.password, formData.confirmPassword)
        } else {
          response = await tryResettingPasswordForNewAndExpiredUser(formData.password, formData.confirmPassword)
        }
        if (response) {
          setState((prevState) => ({ ...prevState, steps: prevState.steps + 1 }))
        }
        hideLoader()
      } catch (error) {
        console.error('Error resetting password', error)
      }
    } else {
      setState((prevState) => ({ ...prevState, confirmPasswordError: 'Passwörter stimmen nicht überein' }))
    }
  }

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      handleSubmit()
    }
  }

  const navigateToLogin = () => {
    navigate('/login')
  }

  return (
    <div className='login-container'>
      <div className='logo' onClick={goToHomePage} />
      <Card className='login-card p-8'>
        <div
          className='login-left flex-center flex-d-column'
          style={{
            backgroundImage: `url('${CDN_URL}/workshop-portal/static-images/login-bg.svg')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '326px'
          }}
        >
          <div className='font-weight-700 gp-text24 text-white tracking-0 gp-lh28 gp-mb20'>{t('pageTitle')}</div>
          <p>
            {t('pageSubtitle')}
          </p>
        </div>
        {steps === 1 &&
          (
            <CardContent className='login-right login-right d-flex flex-d-column justify-content-center' style={{ height: '326px' }}>
              <h2 className='font-weight-700 gp-text24 tracking-0 gp-lh28 gp-mb8'>{t('resetPasswordHeading')}</h2>
              <p className='subheading'>
                {t('enterNewPassword')} {resetPasswordEmail}
              </p>

              <div className='form-group'>
                <Label htmlFor='password' className='gp-mb8 required'>{t('password')}</Label>
                <div className='password-wrapper'>
                  <Input
                    id='password'
                    name='password'
                    value={formData.password}
                    type={showPassword.password ? 'text' : 'password'}
                    placeholder='*************'
                    disableUnderline
                    onKeyPress={handleKeyPress}
                    onChange={handleChange}
                  />
                  <img
                    src={
                      showPassword.password
                        ? `${CDN_URL}/workshop-portal/icons/eye-thin.svg`
                        : `${CDN_URL}/workshop-portal/icons/eye-close-thin.svg`
                    }
                    onClick={() => handleTogglePasswordVisibility('password')}
                    alt='Toggle visibility'
                    className='toggle-password-icon'
                  />

                </div>
                <span style={errorStyle}>{passwordError || ''}</span>
              </div>

              <div className='form-group'>
                <Label htmlFor='password' className='gp-mb8 required'>{t('confirmPassword')}</Label>
                <div className='password-wrapper'>
                  <Input
                    id='confirmPassword'
                    name='confirmPassword'
                    type={showPassword.confirmPassword ? 'text' : 'password'}
                    value={formData.confirmPassword}
                    placeholder='*************'
                    onKeyPress={handleKeyPress}
                    onChange={handleChange}
                  />

                  <img
                    src={
                      showPassword.confirmPassword
                        ? `${CDN_URL}/workshop-portal/icons/eye-thin.svg`
                        : `${CDN_URL}/workshop-portal/icons/eye-close-thin.svg`
                    }
                    onClick={() => handleTogglePasswordVisibility('confirmPassword')}
                    alt='Toggle visibility'
                    className='toggle-password-icon'
                  />
                </div>
                <span style={errorStyle}>{confirmPasswordError || ''}</span>
              </div>

              <Button
                className='login-button bg-[#6926D9]'
                disabled={!formData.password || !formData.confirmPassword}
                onClick={handleSubmit}
              > {t('save')}
              </Button>

            </CardContent>
          )}
        {steps === 2 &&
          (
            <CardContent className='login-right d-flex flex-d-column justify-content-center' style={{ height: '326px' }}>
              <p>{t('passwordSavedAndValid')}</p>
              <Button
                className='login-button bg-[#6926D9]'
                onClick={navigateToLogin}
              >    {t('backToLogin')}
              </Button>
            </CardContent>
          )}
      </Card>
    </div>
  )
}
